"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementAgreementTypeEnum = exports.AgreementToJSON = exports.AgreementFromJSONTyped = exports.AgreementFromJSON = void 0;
function AgreementFromJSON(json) {
    return AgreementFromJSONTyped(json, false);
}
exports.AgreementFromJSON = AgreementFromJSON;
function AgreementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'agreementType': json['agreementType'],
        'accepted': json['accepted'],
    };
}
exports.AgreementFromJSONTyped = AgreementFromJSONTyped;
function AgreementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'agreementType': value.agreementType,
        'accepted': value.accepted,
    };
}
exports.AgreementToJSON = AgreementToJSON;
/**
* @export
* @enum {string}
*/
var AgreementAgreementTypeEnum;
(function (AgreementAgreementTypeEnum) {
    AgreementAgreementTypeEnum["TERMSANDCONDITIONS"] = "TERMS_AND_CONDITIONS";
    AgreementAgreementTypeEnum["CERTIFYACCURATEDATA"] = "CERTIFY_ACCURATE_DATA";
    AgreementAgreementTypeEnum["PROMOTIONALMARKETING"] = "PROMOTIONAL_MARKETING";
    AgreementAgreementTypeEnum["GUARDIANAUTHORIZATION"] = "GUARDIAN_AUTHORIZATION";
    AgreementAgreementTypeEnum["BIPA"] = "BIPA";
})(AgreementAgreementTypeEnum = exports.AgreementAgreementTypeEnum || (exports.AgreementAgreementTypeEnum = {}));
//# sourceMappingURL=Agreement.js.map